export { DMS_MODULE } from '../constants';
export const CRUMB_LABEL_KEY = 'edtVozidloCheckin';
export const NAME = 'VozidloCheckIn';
export const MENU_CODE = 'CheckIn';
export const MERGE_ZAKAZNIK = 'MergeZakaznik';
export const MERGE_VOZIDLO = 'MergeVozidlo';
export const PHOTO_LIST = 'PhotoList';
export const PENDING_JOB_LIST = 'PendingJoblist';

export const DEPENDENT_TABLES = <const>[MERGE_ZAKAZNIK, MERGE_VOZIDLO, PHOTO_LIST, PENDING_JOB_LIST];
export type DependentTableNames = typeof DEPENDENT_TABLES[number];

export enum TAB_NAMES {
	STAV = 'Stav',
	FOTOGRAFIE = 'Fotografie',
	POZNAMKA = 'Poznamka',
	OPENDEFECT = 'Opendefect',
}

export const TABS = {
	[TAB_NAMES.STAV]: { id: TAB_NAMES.STAV, labelKey: 'rgFlag' },
	[TAB_NAMES.FOTOGRAFIE]: { id: TAB_NAMES.FOTOGRAFIE, labelKey: 'foto' },
	[TAB_NAMES.POZNAMKA]: { id: TAB_NAMES.POZNAMKA, labelKey: 'Pozn' },
	[TAB_NAMES.OPENDEFECT]: { id: TAB_NAMES.OPENDEFECT, labelKey: 'VozZavadaZkt' },
};
